export default "__VITE_ASSET__DNWr7rQj__"